import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        const user = res.data.user;
        setUser(user);
        window.history.replaceState({}, "", window.location.pathname);

        if (user.role === "STUDENT") {
          const meRes = await api.get("/auth/me");
          const completed = meRes.data.profile?.profile_completed;
          navigate(completed ? "/dashboard" : "/onboarding", { replace: true });
        } else if (user.role === "MARKETING_EXECUTIVE") {
          navigate("/me", { replace: true });
        } else if (user.role === "SUPER_ADMIN") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-300" data-testid="auth-callback-loading">
      Signing you in…
    </div>
  );
}
